import './main.css';
import { Link } from "react-scroll";
import React from 'react';
import creative from '../../img/main/creative.png'
import titleUA from '../../img/main/title-ua.svg'
import titleRU from '../../img/main/title-ru.svg'
import {InlineShareButtons} from 'sharethis-reactjs';
import yb_icon from '../../img/yb_icon.svg';
import { t } from 'i18next';

export default class Main extends React.Component {
    constructor(props) {
        super(props);

        this.pageLink = window.location.href.toString();
        this.indexUtm = this.pageLink.indexOf('?');
        this.utm = this.pageLink.slice(this.indexUtm+1);
    }

    render() {
        return (
            <div className='main_wrap'>
                <div className='container main_block'>
                    <div className='main_content main_item'>
                        <div className='main_content_text'>
                            <p className='main_descr main_descr--summit'>{t("main.all_Ukrainian")}</p>
                            <img className={t("main.titleUA")} src={titleUA} alt="" />
                            <img className={t("main.titleRU")} src={titleRU} alt="" />
                            <h1 className='main_title'><span className='blue none'>{t("main.volunteer")}</span><span className='main_summit none'>{t("main.summit")}</span><span className='main_title--small'>"{t("main.subtitle1")}<br/>{t("main.subtitle2")}"</span></h1>
                            <p className='main_descr main_descr-data'>{t("main.date")}, Online</p>
                        </div>
                    </div>
                    <div className='main_btns_wrap'>
                        {/* <a 
                        href={`https://www.youtube.com/watch?v=XuxfA5fL4aw`}
                        className='main_btn main_btn--first main_btn--icon main_btn--small' 
                        target='_blank'
                        rel="noreferrer"
                        >
                        Доєднатись до прямого ефіру <img className='yb_icon' src={yb_icon}></img>
                        </a> */}
                        <div className='main_btns_wrap-bottom'>
                        <InlineShareButtons
                                className='main_button main_btn--share'
                                config={{
                                alignment: 'center',  // alignment of buttons (left, center, right)
                                color: 'transparent',      // set the color of buttons (social, white)
                                enabled: true,        // show/hide buttons (true, false)
                                font_size: 16,        // font size for the buttons
                                labels: 'cta',        // button labels (cta, counts, null)
                                language: 'en',       // which language to use (see LANGUAGES)
                                networks: [           // which networks to include (see SHARING NETWORKS)
                                    'sharethis'
                                ],
                                profiles: {           // social profile links for buttons
                                    twitter: 'sharethis',
                                    facebook: 'sharethis',
                                    instagram: 'sharethis',
                                    youtube: '/channel/UCbM93niCmdc2RD9RZbLMP6A?view_as=subscriber'
                                },
                                padding: 12,          // padding within buttons (INTEGER)
                                radius: 0,            // the corner radius on each button (INTEGER)
                                size: 49,             // the size of each button (INTEGER)

                                // OPTIONAL PARAMETERS
                                url: 'https://events.geekle.us/volosamit/?utm_source=website&utm_medium=sharelink', // (defaults to current url)
                                description: '',       // (defaults to og:description or twitter:description)
                                title: `UA Volunteers Summit "Ефективне Волонтерство"`,            // (defaults to og:title or twitter:title)
                                }}
                            />
                            <a 
                            href={`https://geekle.us/ticketfree/1654758858661x619410486161047600?lang=ua${this.indexUtm !== -1 ? `&${this.utm}` : ''}`}
                            className='main_btn main_btn--first'
                            target='_blank'
                            rel="noreferrer"
                            >
                            {t("main.registration")}
                            </a>
                            <Link
                            activeClass="active"
                            to='become'
                            spy={true}
                            smooth={true}
                            offset={-80}
                            className='main_btn main_btn--white'
                            >
                            {t("main.speakers")}
                            </Link>
                        </div>
                    </div>
                </div>
                {/* <div className='main_img_block main_item'>
                        <img className='main_img' src={creative} alt="" />
                    </div> */}
            </div>
        )
    }
}